<template>
  <v-form-create
    v-if="access.create_supplier"
    name="supplier"
    top_title="create_supplier"
  >
    <v-form v-model="is_valid">
      <v-text-field
        v-model="supplier.supplier_name"
        :label="$t('supplier_name')"
        ref="supplier_name"
        :rules="[fieldRules.required]"
        autocomplete="off"
      />
      <v-text-field
        v-model="supplier.contact"
        :label="$t('contact')"
        autocomplete="off"
      />
      <v-text-field
        v-model="supplier.email"
        :label="$t('email')"
        autocomplete="off"
      />
      <v-text-field
        v-model="supplier.inn"
        :label="$t('inn')"
        ref="inn"
        autocomplete="off"
        :rules="[fieldRules.numberString(9)(supplier.inn)]"
      />

      <v-btn v-if="contract_numbers.length > 0" text color="primary" @click="addOptionClicked">
          <v-icon>mdi-plus-circle-outline</v-icon>add contract
      </v-btn>

      <v-list-item
        v-for="(contract_number, index) in contract_numbers"
        v-bind:key="index"
      >
        <!-- <v-list-item-icon style="margin-right: 10px">
          <v-icon>mdi-menu</v-icon>
        </v-list-item-icon> -->
        <v-list-item-content class="ma-0">
          <v-layout row class="pa-0 ma-0">
            <v-flex md12 class="ma-0 pa-0 px-1">
              <v-text-field
                v-model="contract_numbers[index]"
                label="Contract number"
                :rules="[fieldRules.numberString(null)(contract_numbers[index])]"
                @focus="$event.target.select()"
              />
            </v-flex>
          </v-layout>
        </v-list-item-content>
        <v-list-item-action>
          <v-btn icon @click="removeVariant(index)">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>
        <v-btn text color="primary" @click="addOptionClicked">
          <v-icon>mdi-plus-circle-outline</v-icon>add contract
        </v-btn>
      <v-divider />
      <v-text-field
        v-model="supplier.phone_number"
        :label="$t('phone_number')"
        ref="phone_number"
        :rules="[
          fieldRules.required,
          fieldRules.validPhone(supplier.phone_number),
        ]"
        placeholder="+998 (XX) XXX - XX - XX"
        v-mask="masks.phone_number"
        autocomplete="off"
      />
      <v-text-field
        v-model="supplier.website"
        :label="$t('website')"
        autocomplete="off"
      />
      <v-text-field
        v-model="supplier.address_first"
        :label="$t('address_1')"
        autocomplete="off"
      />
      <v-text-field
        v-model="supplier.address_second"
        :label="$t('address_2')"
        autocomplete="off"
      />
      <v-layout>
        <v-flex md6 class="pr-1">
          <v-text-field
            v-model="supplier.city"
            :label="$t('city')"
            autocomplete="off"
          />
        </v-flex>
        <v-flex md6 class="pl-1">
          <v-text-field
            v-model="supplier.zip_code"
            :label="$t('postal_zip_code')"
            autocomplete="off"
          />
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex md6 class="pr-1">
          <v-combobox
            v-model="supplier.country"
            v-bind:items="countries"
            :label="$t('country')"
          />
        </v-flex>
        <v-flex md6 class="pl-1">
          <v-text-field
            v-model="supplier.region_state_province"
            :label="$t('region_state_province')"
            autocomplete="off"
          />
        </v-flex>
      </v-layout>
      <v-text-field
        v-model="supplier.note"
        :label="$t('note')"
        autocomplete="off"
      />
      <v-checkbox
        v-model="supplier.telegram_acces"
        :label="`Access for telegram`"
      ></v-checkbox>
    </v-form>
    <template #action>
      <v-btn text v-on:click="$to('/inventory/suppliers')">
        {{ $t("cancel") }}
      </v-btn>
      <v-btn
        text
        :loading="loading_supplier"
        color="success"
        v-on:click="save_supplier('/inventory/suppliers')"
        :disabled="saveDisabled"
      >
        {{ $route.params["target"] == "update" ? $t("update") : $t("save") }}
      </v-btn>
    </template>
  </v-form-create>
  <error404 v-else></error404>
</template>
<script>
import Suppliers from "../../mixins/inventory/supplier";
export default {
  name: "SupplierCreate",
  mixins: [Suppliers],
  computed: {
    form() {
      return {
        supplier_name: this.supplier.supplier_name,
        phone_number: this.supplier.phone_number,
        // telegram_acces: this.supplier.telegram_acces,
      };
    },
    saveDisabled() {
      let formHasErrors = false || !this.is_valid;
      Object.keys(this.form).forEach((f) => {
        if (!this.form[f]) formHasErrors = true;
      });
      return formHasErrors;
    },
  },
  watch: {
    supplier(supplier) {
      supplier.telegram_access = this.telegram_access;
    },
  },
  beforeMount() {
    this.access = this.$store.state.access;
  },
  data: () => ({
    countries: [{ text: "Uzbekistan", value: "uz" }],
    is_valid: false,
    loading_supplier: false,
    telegram_acces: true,
    contract_numbers: [],
  }),
  methods: {
    addOptionClicked() {
      if (this.contract_numbers.length < 5) {
        this.contract_numbers.push('');
      }
      this.supplier.contract_numbers = this.contract_numbers
    },
    removeVariant(rmInd) {
      this.contract_numbers = this.contract_numbers.filter((_v, currIndx) => currIndx !== rmInd);
      this.supplier.contract_numbers = this.contract_numbers
    },
  },
};
</script>
